import { HistoryFold, PointLine, splitTimeline } from '../requests/Timeline';
import { DayAnswer, QuestionHead } from './MyDayPanel';
import { questionTitle, type MyQuestion } from './myCalendar';

/**
 * „Zapytania” of „Lista” in „Mój kalendarz” (owner 2026-10-28 21:32; 2026-10-30 21:38 „zakładka lista wyświetla tylko
 * ostatnią decyzję odnośnie każdego z wydarzeń”; 21:49 „niech się usuną zapytania do przeszłych albo nieaktywnych”): my
 * active questions — the ones waiting for my answer on top, then the newest (the server's order) — each with ONLY its
 * newest point, the decision I may still re-click („Tak” / „Nie” per day, pressed by the day as it stands); the earlier
 * points folded under „Historia (N)”, read-only, as they were.
 */
export function MyQuestions({ questions, today, answering, answerError, onAnswer }: { questions: readonly MyQuestion[]; today: string; answering: { id: string } | null; answerError: string | null; onAnswer: (id: string, day: string, yes: boolean) => void }) {
  const active = questions.filter((q) => q.active !== false);
  return (
    <section className="mc-list" aria-labelledby="mc-list-title" data-feature-id="crew.my_availability">
      <h2 id="mc-list-title">Zapytania</h2>
      {answerError && (
        <p className="alert" role="alert">
          {answerError}
        </p>
      )}
      {active.length === 0 ? (
        <p className="muted">Nie masz aktualnych zapytań o dostępność. Wcześniejsze są w „Historii”.</p>
      ) : (
        <ul className="mc-qlist" aria-label="Moje zapytania">
          {active.map((q) => {
            const { latest, earlier } = splitTimeline(q.timeline);
            return (
              <li key={q.id} aria-label={questionTitle(q)} className={q.answer === null && q.canAnswer ? 'waiting' : undefined}>
                <QuestionHead q={q} />
                <div className="mc-latest" role="group" aria-label="Ostatnia decyzja">
                  {latest && latest.kind !== 'sent' && <PointLine point={latest} mine as="div" />}
                  <div className="mc-qdays">
                    {q.days.map((d) => (
                      <DayAnswer key={d.day} q={q} day={d.day} today={today} busy={answering?.id === q.id} onAnswer={onAnswer} showDay />
                    ))}
                  </div>
                </div>
                <HistoryFold points={earlier} mine />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
